import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { APP_URL } from '../config';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 720.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
        >
          <path d="M4208 7233 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
          <path d="M4283 7233 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z" />
          <path
            d="M4973 7133 c4 -3 -1 -12 -11 -20 -15 -11 -13 -12 11 -2 30 14 36 29
10 29 -9 0 -13 -3 -10 -7z"
          />
          <path
            d="M3215 7101 c-20 -6 -55 -24 -175 -89 -168 -91 -244 -124 -195 -85
l20 16 -20 -8 c-35 -14 -148 -23 -230 -19 -44 2 -83 4 -87 4 -4 0 -9 8 -12 18
-7 20 -56 52 -81 52 -9 0 -32 -7 -51 -16 -37 -18 -60 -68 -49 -105 11 -34 63
-79 91 -79 34 0 80 28 93 57 l11 23 252 -1 c139 0 261 -4 271 -8 15 -5 5 -15
-48 -49 -57 -36 -70 -50 -92 -99 -14 -32 -28 -75 -30 -95 l-6 -38 -277 0 -278
0 -13 29 c-26 58 -108 88 -162 59 -52 -27 -81 -82 -71 -134 7 -40 59 -89 102
-99 42 -9 96 17 124 59 l23 35 260 3 c143 2 268 1 277 -1 18 -3 22 -13 33 -73
3 -21 17 -50 32 -64 14 -14 22 -28 18 -32 -4 -4 -100 -5 -213 -3 l-207 3 -25
29 c-16 19 -38 32 -62 36 -33 5 -41 2 -74 -31 -31 -31 -36 -41 -30 -69 8 -45
57 -87 100 -87 27 0 41 7 64 35 l29 36 153 -3 c91 -2 155 -7 157 -13 3 -11
-63 -35 -97 -35 -11 0 -20 -3 -20 -7 1 -16 271 -173 296 -173 8 0 38 15 67 33
29 18 98 55 154 82 93 45 117 65 77 65 -8 0 -12 -4 -9 -10 3 -5 -7 -12 -22
-16 -15 -4 -35 -12 -43 -19 -8 -7 -26 -16 -40 -20 -16 -4 -10 3 18 20 l44 27
-52 24 c-29 13 -59 24 -69 24 -9 0 -25 11 -35 25 -10 13 -40 31 -66 40 -27 9
-54 23 -60 30 -7 8 -17 12 -24 8 -6 -3 -8 -3 -4 1 3 4 -3 29 -14 54 -28 66
-22 168 13 237 28 53 66 84 209 165 146 84 179 104 176 108 -3 2 -24 -8 -49
-22 -53 -32 -86 -34 -37 -3 88 55 119 87 85 87 -8 0 -15 6 -15 14 0 24 -40 45
-74 40 l-31 -6 25 21 c25 21 16 26 -25 12z m-732 -173 c21 -25 21 -47 -1 -74
-49 -60 -128 -17 -108 59 11 47 74 55 109 15z m440 -268 c-3 -12 -8 -19 -11
-16 -5 6 5 36 12 36 2 0 2 -9 -1 -20z m-660 -52 c25 -30 22 -74 -9 -105 -21
-21 -32 -25 -66 -20 -44 6 -67 29 -68 69 0 41 10 59 44 74 38 17 75 10 99 -18z
m644 -10 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m-449 -224 c31
-22 26 -63 -10 -83 -24 -14 -28 -14 -47 3 -27 25 -27 61 1 80 28 20 28 20 56
0z m592 -44 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4
11 -10z m120 -149 c0 -12 -20 -25 -27 -18 -7 7 6 27 18 27 5 0 9 -4 9 -9z
m-40 -26 c0 -8 -52 -26 -58 -20 -3 2 6 9 19 14 28 11 39 13 39 6z"
          />
          <path
            d="M4875 7065 c-33 -19 -56 -35 -51 -35 10 0 116 60 116 66 0 6 -2 6
-65 -31z"
          />
          <path d="M3350 7025 c7 -8 16 -12 21 -9 13 8 1 24 -18 24 -13 0 -13 -3 -3 -15z" />
          <path d="M4745 6990 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
          <path
            d="M3604 6924 c-18 -14 -18 -14 6 -3 31 14 36 19 24 19 -6 0 -19 -7 -30
-16z"
          />
          <path
            d="M3518 6875 c-41 -22 -69 -45 -54 -45 7 0 106 62 106 66 0 6 -1 5 -52
-21z"
          />
          <path
            d="M4466 6835 c-11 -8 -15 -15 -10 -15 6 0 19 7 30 15 10 8 15 14 9 14
-5 0 -19 -6 -29 -14z"
          />
          <path
            d="M3308 6757 c-70 -40 -150 -84 -177 -99 -28 -16 -51 -32 -51 -37 0
-11 261 -161 281 -161 8 0 30 10 49 22 19 12 123 71 230 131 199 111 271 157
145 93 -38 -19 -81 -42 -95 -50 -157 -91 -300 -163 -300 -152 0 2 24 19 53 37
123 78 272 172 276 176 8 6 -5 12 -39 18 -19 3 -60 15 -90 26 -92 33 -87 30
-65 39 20 8 20 9 -1 9 -11 1 -95 -37 -186 -84 -92 -47 -169 -85 -173 -85 -10
0 79 60 140 95 65 37 145 87 145 92 0 8 -23 -3 -142 -70z m375 -44 c-7 -2 -19
-2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m-323 -233 c0 -5 -7 -7 -15 -4 -8
4 -15 8 -15 10 0 2 7 4 15 4 8 0 15 -4 15 -10z"
          />
          <path d="M4408 6813 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M3937 6794 c-16 -9 -27 -18 -24 -20 3 -3 20 4 38 15 39 24 28 28 -14
5z"
          />
          <path
            d="M3865 6750 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"
          />
          <path
            d="M2677 6713 c-20 -38 -25 -75 -9 -80 7 -3 12 5 12 21 0 13 5 37 10 52
14 37 5 42 -13 7z"
          />
          <path d="M3910 6610 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z" />
          <path
            d="M3791 6543 l-44 -27 89 -28 c49 -15 93 -27 98 -25 6 2 -13 11 -41 20
-28 9 -64 22 -79 27 l-28 11 29 24 c39 31 31 31 -24 -2z"
          />
          <path d="M4420 6560 c8 -5 22 -9 30 -9 10 0 8 3 -5 9 -27 12 -43 12 -25 0z" />
          <path
            d="M4500 6527 c0 -4 14 -26 30 -49 17 -22 30 -46 30 -53 0 -8 -24 -15
-62 -19 -34 -3 -76 -10 -92 -16 -17 -5 -44 -12 -60 -15 -63 -13 -15 -12 79 2
55 8 114 17 132 19 l32 5 -30 52 c-31 52 -59 88 -59 74z"
          />
          <path
            d="M2652 6471 c2 -26 9 -46 16 -49 10 -3 12 5 6 34 -10 58 -26 68 -22
15z"
          />
          <path
            d="M3975 6445 c17 -8 37 -14 45 -14 8 0 -1 7 -20 14 -46 18 -64 17 -25
0z"
          />
          <path
            d="M5007 6450 c-39 -12 -58 -29 -74 -67 l-13 -33 -299 0 c-165 0 -307
-3 -316 -7 -15 -5 -16 -3 -6 15 10 18 9 21 -4 16 -12 -5 -14 -15 -10 -38 6
-31 6 -31 -12 -10 -27 31 -81 60 -143 77 -30 8 -64 18 -75 21 -13 5 -11 2 5
-7 14 -8 45 -21 70 -28 108 -31 145 -72 145 -157 0 -67 -19 -97 -80 -131 -91
-51 -267 -147 -365 -201 -212 -115 -526 -288 -570 -314 -44 -25 -49 -26 -233
-26 -123 0 -186 -3 -182 -10 4 -6 73 -8 193 -4 190 5 226 12 292 54 14 9 39
21 55 28 28 12 29 11 10 -3 -11 -9 -52 -34 -92 -56 -64 -35 -82 -41 -160 -46
-119 -8 -125 -13 -66 -51 28 -18 52 -32 55 -32 3 0 43 -22 89 -50 46 -27 91
-50 100 -50 8 0 35 13 60 28 81 52 540 295 545 289 3 -3 -5 -12 -18 -20 -12
-8 -50 -32 -83 -52 -79 -50 -332 -198 -419 -245 l-69 -38 -66 36 c-36 20 -68
39 -71 42 -3 4 -25 18 -50 32 -25 14 -69 40 -99 57 -67 40 -78 35 -13 -6 98
-62 289 -173 298 -173 9 0 105 54 244 135 36 21 90 52 120 68 30 17 57 33 60
37 3 3 82 50 175 104 304 175 349 202 434 255 46 28 101 72 123 96 l40 45 103
0 c99 0 102 -1 113 -25 13 -27 67 -65 94 -65 51 0 97 47 105 107 6 46 -48 103
-98 103 -41 0 -95 -31 -104 -59 -6 -21 -12 -21 -257 -21 l-250 0 41 46 c42 48
46 63 41 152 l-2 42 301 0 301 0 17 -34 c22 -48 96 -81 144 -65 54 18 88 65
89 122 0 40 -5 53 -32 82 -36 37 -83 50 -131 35z m78 -46 c24 -10 46 -60 39
-89 -8 -31 -49 -65 -79 -65 -12 0 -34 9 -49 21 -70 55 4 165 89 133z m-212
-305 c12 -7 25 -17 29 -23 12 -18 9 -53 -5 -68 -8 -7 -12 -18 -10 -24 5 -15
-69 -4 -89 14 -25 21 -23 70 4 93 24 22 41 24 71 8z m-898 -159 c-3 -5 -11
-10 -16 -10 -6 0 -7 5 -4 10 3 6 11 10 16 10 6 0 7 -4 4 -10z m-433 -235 c-34
-19 -66 -35 -70 -35 -11 1 111 70 123 70 6 0 -18 -16 -53 -35z m503 15 c-3 -5
-11 -10 -16 -10 -6 0 -7 5 -4 10 3 6 11 10 16 10 6 0 7 -4 4 -10z m-600 -70
c-3 -5 -11 -10 -16 -10 -6 0 -7 5 -4 10 3 6 11 10 16 10 6 0 7 -4 4 -10z"
          />
          <path
            d="M3685 6341 c-38 -20 -128 -68 -200 -105 -71 -38 -143 -77 -160 -86
-16 -10 -97 -52 -180 -95 -142 -73 -179 -95 -161 -95 9 0 483 245 561 290 17
10 71 39 120 65 50 26 94 51 100 56 18 17 -10 7 -80 -30z"
          />
          <path d="M2198 6353 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z" />
          <path
            d="M3729 6327 c-76 -40 -138 -73 -319 -175 -213 -119 -272 -152 -277
-152 -2 0 -29 -16 -59 -35 -30 -19 -56 -35 -59 -35 -8 0 -95 -61 -95 -67 0 -3
7 0 16 8 13 10 17 10 24 0 4 -8 12 -11 18 -7 6 3 18 3 29 -1 15 -6 13 -9 -12
-14 -28 -6 -28 -7 -5 -8 29 -1 100 -56 100 -77 0 -8 9 -14 21 -14 13 0 18 4
13 12 -5 7 -3 8 5 4 7 -5 39 5 74 22 149 72 237 112 246 112 6 0 11 5 11 10 0
6 8 10 18 10 15 0 -54 -53 -83 -64 -5 -2 -6 -7 -2 -12 4 -5 11 -4 15 1 4 6 27
21 52 33 104 54 261 138 350 187 52 29 137 74 187 101 51 27 93 52 93 55 0 4
-8 9 -17 12 -10 2 -27 8 -38 12 -16 5 -17 5 -5 -4 18 -13 3 -13 -25 -1 -13 6
-15 9 -5 9 17 1 10 6 -97 62 -101 53 -102 54 -174 16z m-742 -443 c-3 -3 -12
-4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"
          />
          <path
            d="M3129 6317 c6 -8 22 -17 34 -20 12 -2 31 -8 42 -12 13 -5 17 -5 10 2
-5 6 -30 18 -54 27 -36 14 -42 14 -32 3z"
          />
          <path d="M3238 6273 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M4587 6240 c-12 -33 -37 -114 -37 -118 0 -2 6 1 14 7 16 14 40 94 33
113 -4 10 -6 10 -10 -2z"
          />
          <path d="M5028 6053 c23 -2 59 -2 80 0 20 2 1 4 -43 4 -44 0 -61 -2 -37 -4z" />
          <path
            d="M2920 5935 c-25 -13 -41 -24 -37 -25 11 0 87 39 87 45 0 7 0 7 -50
-20z"
          />
          <path
            d="M2748 5849 c-65 -32 -118 -61 -118 -64 0 -3 54 22 120 55 66 33 120
62 120 65 0 7 7 10 -122 -56z"
          />
          <path d="M3339 5820 l-24 -20 33 16 c32 15 40 24 23 24 -5 0 -19 -9 -32 -20z" />
          <path
            d="M2453 5702 c-84 -42 -152 -80 -153 -83 0 -8 127 -5 136 4 4 4 -15 7
-42 8 -45 0 -47 1 -24 12 14 6 27 14 30 18 3 3 30 17 60 31 66 30 169 88 155
87 -5 0 -78 -35 -162 -77z"
          />
          <path d="M2458 5622 c12 -8 72 -4 72 4 0 2 -19 4 -42 4 -26 0 -38 -4 -30 -8z" />
          <path
            d="M1952 4928 c-1 -12 -11 -18 -27 -19 -14 -1 -29 -3 -35 -4 -5 -1 -19
-3 -30 -4 -19 -1 -20 -8 -20 -216 l0 -215 65 0 65 0 -1 128 c-2 124 -14 364
-17 330z"
          />
          <path
            d="M3863 4919 c-44 -28 -60 -86 -41 -148 22 -72 48 -84 188 -91 74 -4
124 -11 134 -19 19 -16 21 -64 3 -80 -8 -6 -76 -12 -172 -13 l-159 -3 -18 -47
-18 -48 188 0 c162 0 193 3 229 19 56 26 76 59 77 130 1 111 -43 142 -212 149
-104 4 -114 6 -128 27 -22 33 -4 70 36 79 18 3 88 6 156 6 l124 0 0 32 c0 24
-3 29 -12 20 -8 -8 -17 -8 -30 -1 -13 7 -23 7 -31 1 -7 -6 -72 -12 -145 -14
-120 -3 -154 2 -119 15 8 4 7 6 -3 6 -8 0 -30 -9 -47 -20z"
          />
          <path
            d="M2771 4905 c-1 -22 -4 -26 -10 -16 -12 19 -50 24 -66 11 -10 -8 -14
-6 -17 7 -2 10 -7 -80 -11 -200 -4 -120 -5 -223 -2 -228 4 -5 33 -9 66 -9 l59
0 0 123 0 122 48 -52 c26 -28 76 -83 111 -122 l64 -71 78 0 c44 0 79 3 79 8 0
4 -54 61 -120 127 -66 66 -120 124 -120 130 0 6 8 18 18 26 44 40 144 150 140
155 -3 2 -11 -2 -18 -11 -14 -17 -40 -20 -40 -4 0 5 4 8 9 4 5 -3 12 -1 16 5
10 16 -22 12 -39 -5 -27 -28 -50 -14 -23 15 35 38 -40 -24 -113 -94 -45 -42
-84 -75 -87 -72 -2 2 -8 44 -12 93 -5 48 -9 75 -10 58z"
          />
          <path
            d="M2177 4897 c-12 -15 -17 -17 -17 -7 0 13 -2 13 -10 0 -7 -12 -10 -12
-10 -1 0 7 -6 11 -14 8 -8 -3 -17 -1 -19 6 -2 7 -7 10 -10 7 -7 -6 56 -109
111 -181 l42 -56 0 -101 0 -102 65 0 65 0 0 101 0 100 80 111 c44 61 80 118
80 127 -1 14 -2 14 -14 -2 -12 -15 -18 -16 -35 -7 -12 6 -21 7 -21 3 0 -4 -4
-2 -9 5 -10 17 -40 -11 -91 -86 -19 -28 -40 -53 -46 -56 -7 -2 -26 15 -43 39
-18 25 -37 50 -44 57 -7 7 -20 23 -28 35 l-15 21 -17 -21z"
          />
          <path
            d="M3237 4906 c-4 -10 -7 -112 -7 -227 l0 -209 196 2 197 3 12 42 c7 23
10 45 7 48 -3 3 -70 5 -149 5 l-143 0 0 55 0 55 120 0 120 0 0 40 0 40 -120 0
-120 0 0 60 0 60 140 0 c139 0 140 0 139 23 0 21 -1 21 -9 2 -5 -11 -9 -14 -9
-7 -1 17 -351 16 -352 -2 0 -6 -4 -2 -8 8 -7 18 -8 18 -14 2z"
          />
          <path
            d="M4356 4890 c-3 -18 -6 -98 -6 -177 0 -167 8 -191 75 -223 34 -17 62
-20 163 -20 66 0 133 5 149 11 85 32 106 98 97 299 -4 80 -9 140 -11 135 -2
-6 -25 -9 -52 -8 l-50 2 -3 -154 c-4 -186 -4 -186 -104 -186 -108 -1 -112 0
-128 17 -13 12 -16 40 -17 137 0 104 -14 242 -18 182 -1 -12 -4 -16 -9 -9 -4
5 -20 10 -37 10 -16 -1 -33 3 -36 7 -3 5 -9 -6 -13 -23z"
          />
          <path
            d="M4936 4904 c-3 -8 -6 -110 -6 -226 l0 -210 188 4 c207 3 238 11 267
68 29 57 12 140 -35 173 l-21 15 25 37 c28 41 31 60 16 99 -7 20 -16 26 -40
26 -16 0 -30 3 -30 8 0 4 -75 6 -167 6 -93 -1 -173 2 -179 7 -8 6 -14 4 -18
-7z m324 -44 c15 -23 12 -62 -7 -82 -13 -15 -32 -18 -109 -18 l-92 0 -4 53
c-3 28 -2 56 0 60 2 5 49 7 104 5 74 -2 101 -7 108 -18z m15 -196 c10 -10 15
-29 13 -48 -4 -44 -35 -56 -145 -56 l-93 0 0 60 0 60 104 0 c83 0 108 -3 121
-16z"
          />
          <path
            d="M3160 4290 c-175 -3 -19 -6 400 -6 377 0 669 1 650 2 -71 7 -773 9
-1050 4z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  // Render as external link
  return (
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      {logo}
    </a>
  );
}
